'use client'

import React from "react";
import Image from "next/image";
import { useSelector } from "react-redux";
import styled from "styled-components";
import FormPage from "./FormPage";

function MobileApp() {
  const language = useSelector((state) => state.language.language);
  const text = {
    titleFirst: language === "en" ? "Experience Salon-Quality Beauty Services at Home with Door to Door Beauty in Noida" : "नोएडा में डोर टू डोर ब्यूटी के साथ घर पर सैलून-गुणवत्ता वाली ब्यूटी सेवाओं का अनुभव करें",
    titleSecond: language === "en" ? "through DTDB." : "बुक करें।",
    description: language === "en" 
        ? "Experience top-notch beauty services at your doorstep with Door To Door Beauty. With over two years of expertise, we bring salon-quality treatments directly to your home. Whether it's a quick facial, a relaxing massage, or a full body polish, our professional beauticians ensure you get the best care in the comfort of your own space. Booking is easy and convenient, allowing you to schedule your beauty session at a time that suits you best. Pamper yourself with the luxury you deserve—anytime, anywhere." 
        : "डोर टू डोर ब्यूटी के साथ अपने दरवाजे पर बेहतरीन ब्यूटी सेवाओं का अनुभव करें। दो से अधिक वर्षों की विशेषज्ञता के साथ, हम सैलून-स्तरीय ट्रीटमेंट सीधे आपके घर पर लाते हैं। चाहे वह एक त्वरित फेशियल हो, एक आरामदायक मसाज हो, या एक फुल बॉडी पॉलिश हो, हमारे पेशेवर ब्यूटीशियन यह सुनिश्चित करते हैं कि आपको अपने आरामदायक स्थान में बेहतरीन देखभाल मिले। बुकिंग करना आसान और सुविधाजनक है, जिससे आप अपनी ब्यूटी सत्र को अपनी सुविधा के अनुसार शेड्यूल कर सकते हैं। खुद को वह विलासिता दें जिसकी आप हकदार हैं—कभी भी, कहीं भी।",
  };

  return (
    <div className="bg-indigo-100 w-full mt-[-20px] sm:mt-[10px]">
      <div 
        id="downloadApp" 
        className="bg-indigo-100 py-5 lg:py-10 bg-repeat bg-center overflow-hidden  lg:h-[475px] flex items-center"
      >
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-10 w-full h-full flex items-center">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full h-full items-center justify-center">

            {/* Left Image */}
            <div className="hidden lg:flex justify-start items-center">
              <Image
                src="/assets/AppImage/appImage5.png"
                alt="App Banner Left"
                width={400} // Adjust size as needed
                height={500}
                className="block w-full max-w-md"
                priority
              />
            </div>

            {/* Center Content */}
            <div className="text-center flex flex-col justify-center items-center h-full px-4">
              <h2
                style={{
                  fontSize: '1.4rem',
                  color: '#000000',
                  fontFamily: 'Roboto, sans-serif',
                    lineHeight: '1.2', // reduces the space between lines
                    marginTop:'-10px',
                    marginBottom:'20px'
                }}
                className="text-xl lg:text-2xl mb-2 font-semibold"
              >
                {text.titleFirst}
                <br />
                {text.titleSecond}
              </h2>
              <p
                style={{
                  fontSize: '1rem',
                  color: '#000000',
                  fontFamily: 'Roboto, sans-serif',
                  lineHeight: '1.5',
                  margin: '0 0 10px',
                  textAlign: 'justify',
                }}
              >
                {text.description}
              </p>
            </div>

            {/* Form Section */}
            <div className="flex justify-end items-center h-full lg:-mt-4">
              <div className="max-w-md w-full h-full lg:-mt-[115px]">
                <FormPage />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileApp;